/* unplugin-vue-components disabled */const { computed, ref, onBeforeMount } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "program-wrap"
};
const vue_3 = require("vue");
const continuous_toolbox_1 = require("@blockly/continuous-toolbox");
const index_vue_1 = tslib_1.__importDefault(require("@/views/program/components/ProgramPanel/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("@/views/program/components/Blockly/index.vue"));
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const project_1 = require("@/service/project");
const router_1 = tslib_1.__importDefault(require("@/router"));
const user_1 = require("@/service/user");
const one_message_1 = require("@/utils/one_message");
exports.default = (0, vue_1.defineComponent)(Object.assign({
    name: 'program'
}, { __name: 'index', setup(__props) {
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        function onUpdateCode(evt) {
            console.log(evt);
        }
        const options = {
            media: "/static/media/",
            grid: {
                spacing: 25,
                length: 2,
                colour: "#7a7cbf",
                snap: true,
            },
            move: {
                scrollbars: {
                    vertical: true,
                    horizontal: true,
                },
                wheel: true,
            },
            zoom: {
                startScale: 0.9,
            },
            plugins: {
                'flyoutsVerticalToolbox': continuous_toolbox_1.ContinuousFlyout,
                'metricsManager': continuous_toolbox_1.ContinuousMetrics,
            },
        };
        const block = ref();
        function handleAddVar(id, name, type) {
            if (!block.value)
                return;
            block.value.createVar(id, name, type);
        }
        function handleDelVar(id) {
            if (!block.value)
                return;
            block.value.deleteVar(id);
        }
        const store = (0, work_1.useWork)();
        onBeforeMount(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            const selectProgram = () => {
                var _a, _b, _c, _d;
                const curProgram = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram;
                const curRobot = curProgram === null || curProgram === void 0 ? void 0 : curProgram.robot;
                let curRobotId;
                let curProgramId;
                if ((curRobot === null || curRobot === void 0 ? void 0 : curRobot.type) == model_1.ENTITY_TYPE.ROBOT) {
                    curRobotId = curRobot.id;
                    curProgramId = (_b = curRobot.code.programs.find(e => e.name === '主程序')) === null || _b === void 0 ? void 0 : _b.id;
                }
                else {
                    let robots = (_c = model_1.Project.current()) === null || _c === void 0 ? void 0 : _c.findMachineByType(model_1.ENTITY_TYPE.ROBOT);
                    if (robots === null || robots === void 0 ? void 0 : robots.length) {
                        curRobotId = robots[0].id;
                        curProgramId = (_d = robots[0].code.programs.find(e => e.name === '主程序')) === null || _d === void 0 ? void 0 : _d.id;
                    }
                }
                model_1.Project.current().selectProgram(curRobotId, curProgramId);
            };
            if (curPage.value === "program" && !model_1.Project.current()) {
                try {
                    yield project_1.ProjectService.current().openLastOpenProject();
                }
                catch (e) {
                    if (e.message.includes("无工程，请新建")) {
                        if (yield user_1.permService.hasDesign()) {
                            yield router_1.default.push({ name: 'design' });
                            return;
                        }
                        else {
                            one_message_1.oneMessage.error("账号暂无权限创建项目，请联系管理员。");
                        }
                    }
                    console.log(e);
                }
            }
            let robots = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineByType(model_1.ENTITY_TYPE.ROBOT);
            if (robots === null || robots === void 0 ? void 0 : robots.length) {
                selectProgram();
            }
            else {
                if (yield user_1.permService.hasDesign()) {
                    yield router_1.default.push({ name: 'design' });
                }
                else {
                    (0, one_message_1.oneMessage)({
                        message: "无程序，请联系工程师",
                        grouping: true,
                        type: 'warning'
                    });
                }
            }
        }));
        (0, vue_3.onMounted)(() => {
            var _a;
            const curProgram = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram;
            if (curProgram) {
                store.notifyChangeProgram();
            }
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return ((_b = (_a = (0, vue_2.unref)(model_1.Project).current()) === null || _a === void 0 ? void 0 : _a.curProgram) === null || _b === void 0 ? void 0 : _b.robot)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(index_vue_2.default, {
                        class: "blockly",
                        options: options,
                        onUpdateCode: onUpdateCode,
                        ref_key: "block",
                        ref: block
                    }, null, 512),
                    (0, vue_2.createVNode)(index_vue_1.default, {
                        onAddVar: handleAddVar,
                        onDelVar: handleDelVar
                    })
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    } }));
